// Import 3rd-party dependencies
import { Component } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { combineLatest, of } from 'rxjs';

// Import project-specific dependencies
import { QuickLinksService } from '@app/services/quick-links/quick-links.service';
import { PeopleService } from '@app/services/people/people.service';
import { QUICK_LINKS_COMPONENT_CONSTS } from '@app/config/constants';
import { environment } from '@app/environments/environment';

export interface ContentLink {
  title: string;
  link: string;
  description: string;
  country: string[];
}

@Component({
  selector: 'app-quick-links',
  templateUrl: './quick-links.component.html',
  styleUrls: ['./quick-links.component.css']
})
export class QuickLinksComponent {
  consts = QUICK_LINKS_COMPONENT_CONSTS;
  //2296-TH-2295--disable_country_selection_for_UserProfile/MyProfiles/TrendingLink(ITconnect/UPtime)
  //redirect the URL (IT Connect/UPtime) based on the user country which is defiend in the QuickLinks_json file
  /*
  quickLinks$ = combineLatest([this.peopleService.currentUser$, this.quickLinksService.quickLinks$]).pipe(
    switchMap(([user, links]) => {
      const country = user?.country || '';
      const idUPtime = links.findIndex((qlink) => qlink.link.includes(this.consts.UPTIME_URL));
      const idITConnect = links.findIndex((qlink) => qlink.link.includes(this.consts.ITCONNECT_URL));
      const removedLink = links[idUPtime].country.includes(country) ? idITConnect : idUPtime;
      return of(links.filter((link, index) => index !== removedLink).slice(0, this.consts.MAX_QUICKLINKS_COUNT));
    })
  );
  */
  //load from json file
  /*
  quickLinks$ = this.quickLinksService.quickLinks$.pipe(
    map((links) => links.slice(0, this.consts.MAX_QUICKLINKS_COUNT))
  );
  */

  quickLinks$ = this.quickLinksService.quickLinkList$.pipe(
    map((links) => links.sort((a, b) => a.index - b.index).slice(0, this.consts.MAX_QUICKLINKS_COUNT))
  );

  constructor(private quickLinksService: QuickLinksService, private peopleService: PeopleService) {}

  openLink(quickLink: ContentLink): void {
    // redirect people search page based on evnrionments
    const env = environment.production ? environment.APP.URL.PUBLIC : window.location.origin;
    const url = quickLink.link === '/people-search' ? `${env}${quickLink.link}` : quickLink.link;
    window.open(url, '_blank');
  }
}
